// Select elements
const filterButton = document.querySelector('.cta-filter-button');
const collectionSidebar = document.querySelector('.collections__sidebar');
const collectionContainer = document.querySelector('#main-collection-filters');

// Add event listener to toggle class
filterButton.addEventListener('click', () => {
    collectionContainer.classList.toggle('sidebar-close');
});
  